/**
 * LandingPage - 채점톡 랜딩페이지
 *
 * 학원 원장/강사를 위한 서비스 소개 페이지
 * 베타 서비스 가입 유도
 *
 * 섹션 구성:
 * 1. HeroSection - 핵심 메시지 및 CTA
 * 2. ProblemSection - 문제점 공감
 * 3. SolutionSection - 솔루션 소개
 * 4. HowItWorksSection - 작동 방식
 * 5. BetaSection - 베타 참여 안내
 * 6. FooterSection - 푸터 및 피드백
 */

import React from 'react';

// 랜딩 섹션 컴포넌트들
import { HeroSection } from '../components/landing/HeroSection';
import { ProblemSection } from '../components/landing/ProblemSection';
import { SolutionSection } from '../components/landing/SolutionSection';
import { HowItWorksSection } from '../components/landing/HowItWorksSection';
import { BetaSection } from '../components/landing/BetaSection';
import { FooterSection } from '../components/landing/FooterSection';

export const LandingPage: React.FC = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#fff',
      }}
    >
      {/* 히어로 섹션 - 핵심 메시지 및 CTA */}
      <HeroSection />

      {/* 문제점 공감 섹션 */}
      <ProblemSection />

      {/* 솔루션 소개 섹션 */}
      <SolutionSection />

      {/* 작동 방식 섹션 */}
      <HowItWorksSection />

      {/* 베타 참여 안내 섹션 */}
      <BetaSection />

      {/* 푸터 섹션 */}
      <FooterSection />
    </div>
  );
};
